import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=3bfb8bfa&scoped=true&"
import script from "./PublishButton.vue?vue&type=script&lang=js&"
export * from "./PublishButton.vue?vue&type=script&lang=js&"
import style0 from "./PublishButton.vue?vue&type=style&index=0&id=3bfb8bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb8bfa",
  null
  
)

export default component.exports